var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330.4 500",
    style: {
      enableBackground: "new 0 0 330.4 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#010101;stroke-width:25;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 47.4,
    y1: 409.4,
    x2: 127.9,
    y2: 22.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "138.5,22.7 204.6,144 253.4,269.2 304.8,478.2 "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 23.6,
    y1: 280.5,
    x2: 299.5,
    y2: 271.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "58.4,68.7 66.4,240.7 62.4,426.9 53.1,277.8 31.9,99.2 33.6,64.7 49.2,33.8 80,20.9 116.2,24.2 149.2,37.2 180.9,57.7 204.5,83.6 219.1,114.8 217.8,147.3 198.2,171.9 149.2,192.5 122.5,202.8 93,212.8 70.1,217.7 "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "106.5,219.3 140.6,220.6 172,229.5 208.8,250.7 240,278.1 261.6,304.7 280,334.9 296.2,373.9 301.5,404.8 294.2,431 260.6,451.4 219.1,458.6 171.7,456.6 33.8,440.9 "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "283.9,66 264.2,43.4 232.4,26.8 199.5,25.1 163.3,30.4 128.1,47.2 98.5,71 65.4,110.3 45.2,147.6 30.2,187.2 21.9,225.9 27.5,274.6 45.4,314.7 74.8,361.1 105.2,398.5 168.5,446.9 218.9,470.1 240.6,475.7 270.6,476 305.4,470.1 333.9,448.8 "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "141.8,22.6 164.1,267.4 155.6,488.7 128.3,259.4 122.1,132 137.6,65.7 167.3,33.4 211,22.6 261.8,31.4 308.5,64.8 343.7,115.6 363.7,174.6 372.8,253.4 364.3,312 337.8,373.9 298.2,419.4 259.8,439.4 220.7,448.2 96.6,429.1 16.4,417.7 "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 58,
    y1: 47,
    x2: 313,
    y2: 23.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "109.1,19.8 118.3,288 118.3,480.1 "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 80.7,
    y1: 293.4,
    x2: 268,
    y2: 253.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "19.3,464.6 138.1,477.8 338.6,464.6 "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "121.5,28.5 109.1,228.5 113.5,483.4 "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 51.6,
    y1: 232.5,
    x2: 291.5,
    y2: 199.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "28.9,48.3 154.1,43.6 317.5,21.6 "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "363.4,72.7 315.8,35.4 254.4,27.7 188.7,50.2 123.1,87.8 71.6,132.4 38.5,190.3 24.4,240.6 24.4,281.8 47.1,338.9 82.7,386.1 129.9,428.1 180.6,449.6 241.5,453.5 296.5,438.4 363.4,398.9 404.6,351.3 407.6,314 357.4,280.1 144.5,253.4 404.6,260.3 383.6,482.6 "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 68.2,
    y1: 17.3,
    x2: 53.5,
    y2: 482.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 271.8,
    y1: 17.3,
    x2: 267.7,
    y2: 484.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 23.5,
    y1: 238.6,
    x2: 337.2,
    y2: 187.1
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "164.5,24.7 173.4,282.3 160.8,471.1 "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 20.2,
    y1: 75.9,
    x2: 281.6,
    y2: 24.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 60.5,
    y1: 475.3,
    x2: 258.1,
    y2: 451
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "186.2,20.2 260.5,196.5 283.1,288.9 283.1,357.9 264.9,415.2 220.5,462.4 174.1,479.8 119.7,474.9 54.7,442.3 18.4,403.1 "
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "69.4,18.7 101,212.2 92.4,481.3 "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "295.5,49.6 133.4,183.5 26.8,258.2 26.8,275.4 134.1,357.6 250.7,473.4 "
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "83.6,21 48.3,194.5 33.3,363.1 43.9,418.3 70.1,443.8 315.9,479 "
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "53.2,109.9 46.5,311.2 32.2,476.6 53.2,480.3 87.8,384.1 106.6,287.2 95.4,173.7 84.8,67 99.8,19.7 131.4,25 157.7,61.8 190,126.4 214.1,223.7 226.9,310.5 232.7,309.3 227.2,208.1 227.8,128.6 237.6,79.6 257.6,51.4 288.9,59.3 326.1,105.5 361,178.2 386.4,263.9 397.7,347.9 397.7,406.5 384.4,455.5 "
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "52.3,71.8 48.2,264.1 43.7,416.7 43.7,471.3 56.3,471.3 70.6,283.6 70.6,130.3 54.6,22.4 63.7,22.4 158.4,300.8 253.7,477.6 262.9,477.6 311.7,351.3 328.3,244.3 325.5,140.1 308.2,27 "
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "231.6,46 190,35.4 145.2,40.7 101.1,61.5 68.2,94.4 49,138.5 36.6,203.1 36.6,260.2 36.6,321.7 57.7,381.4 87.5,424.2 134.1,459 185.6,475.8 226,470.8 260.8,457.1 311.7,413.6 340.3,369.6 357,319.9 362.6,260.9 355.2,204.4 332.8,138.5 304.2,88.2 274.4,59 239,35.4 174.4,24.2 "
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "245,72.5 219.7,34.6 172.2,22.5 103,62.2 54.9,115.8 32.7,193.4 36.3,269.3 57.9,352.2 97.6,418.9 154.8,445.4 208.9,439.4 252.8,417.1 282.9,369 302.1,311.9 302.1,222.8 289.5,166.3 265.5,118.8 235.4,92.3 187.3,64 93.4,37.6 "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 203.5,
    y1: 261.3,
    x2: 387.6,
    y2: 483.9
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 81.4,
    y1: 81.2,
    x2: 98.2,
    y2: 481.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "111.9,421.9 69.2,219.3 24.1,81.2 24.1,42.1 45.9,18.7 84.5,18.7 125.6,39 152,67 196.7,115.7 224.1,172.1 226.1,213.2 202.3,255.3 151,266 39.3,257.9 41.8,276.1 294.7,476.7 "
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "108.5,79.2 116.7,483 104.4,484.4 103.1,253.5 72.1,69.4 83.6,29.8 110.9,16.6 152.1,27.8 181.7,65.6 213.4,119.8 230.7,177.6 229,244.7 205.2,285.2 174.9,302.2 138.8,309.7 30.6,280.4 "
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "265.6,37.2 209.4,15.6 144.5,18.7 98.1,37.2 51.2,80 46.1,125.3 96.1,174.8 174.9,216.3 255.3,284.5 307.3,345.3 323.8,405.1 292.4,451 237.8,471.1 184.9,474.7 118.2,453.5 46.1,417.5 24.4,389.1 "
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 250.2,
    y1: 42.6,
    x2: 242.7,
    y2: 481.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 21.1,
    y1: 60.5,
    x2: 373.2,
    y2: 18.6
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "62.7,37.2 50,251.2 59.8,323.1 94,390.3 120.7,429.7 153.7,462.2 204.1,465.6 236.6,445.9 288.7,394.9 319.5,342.2 340.3,282.5 356,165.5 350.2,20.6 "
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "37.9,75.3 137.7,476 283.1,20 "
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "32.1,33.4 50,271.9 78.4,407 118.2,473.2 151.3,467.2 196.3,399.7 222.8,208.3 240,342.7 271.1,412.3 326.8,449.3 387,434.8 439.4,368.5 466.5,253.3 466.5,110.3 452.6,26.8 "
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "24.4,54.2 174.1,256.4 316.8,486.1 "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 289.7,
    y1: 19.2,
    x2: 27.6,
    y2: 423.5
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 25.5,
    y1: 22.7,
    x2: 182.7,
    y2: 300.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.5,77.4c0,0-263.2,401.1-260.9,399.9"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "z"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "42.7,28.1 429.3,102.6 49.2,447.7 429.3,482.7 "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndex);
export default __webpack_public_path__ + "static/media/index.31a637f6536e3ecd40e53c168b01f424.svg";
export { ForwardRef as ReactComponent };